(function () {
    'use strict';

    angular
        .module('app')
        .directive('dictionaryEntry', dictionaryEntry);

    dictionaryEntry.$inject = ['$window', 'dictionaryService', 'stringService'];

    function dictionaryEntry($window, dictionaryService, stringService) {
        // Usage:
        //     <dictionaryEntry></dictionaryEntry>
        // Creates:
        // 
        var directive = {
            link: link,
            scope: {},
            restrict: 'EA',
            templateUrl: "/static/Common/js/templates/dictionaryEntry/_dictionaryEntry.html"
        };
        return directive;

        function link($scope, $element, $attrs) {
            var dictionaryKey = $attrs.asbKey;
            var fallbackValue = $attrs.asbFallback;

            if (dictionaryKey !== 'undefined' && dictionaryKey !== '') {
                dictionaryService.gettingPhrase(dictionaryKey, fallbackValue).then(function(phrase) {
                    var finalValue = $attrs.asbValue;
                    if (finalValue !== undefined && finalValue !== '' && finalValue !== null) {
                        $scope.phrase = stringService.format(phrase, [finalValue]);
                    } else {
                        $scope.phrase = phrase;
                    }
                });
            }
        }
    }
})();


//////////////////
// WEBPACK FOOTER
// ./static/common/js/templates/dictionaryEntry/_dictionaryEntry.js
// module id = 15
// module chunks = 0